import React from 'react';

const Cart = () => (
  <svg
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.75 21.25H10.8C8.60625 21.25 6.75 19.675 6.35625 17.5375L3.65625 1.5625H0"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M4.5 6.0625H26.4375L25.0875 12.5875C24.5812 15.0625 22.4438 16.8625 19.9688 17.0312L6.46875 17.875"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M8.71875 27.4375C9.80606 27.4375 10.6875 26.5561 10.6875 25.4688C10.6875 24.3814 9.80606 23.5 8.71875 23.5C7.63144 23.5 6.75 24.3814 6.75 25.4688C6.75 26.5561 7.63144 27.4375 8.71875 27.4375Z"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M22.2188 27.4375C23.3061 27.4375 24.1875 26.5561 24.1875 25.4688C24.1875 24.3814 23.3061 23.5 22.2188 23.5C21.1314 23.5 20.25 24.3814 20.25 25.4688C20.25 26.5561 21.1314 27.4375 22.2188 27.4375Z"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Cart;
